<div class="userDetails ps-5">
  <section class="mt-2">
    @if (contact) {
      <i-title [text]="getTitle()" level="1" [buttons]="titleButtons"></i-title>
    }
  </section>
  <section class="filters">
    <span class="filter-span entrants" [pTooltip]="'contactsDetails.details.isSender' | translate" (click)="openAdvancedSearch('Sender')">
      <i class="bi bi-envelope-open-fill"></i> Courriers expédiés
    </span>
    <span class="filter-span sortants" [pTooltip]="'contactsDetails.details.isRecipient' | translate" (click)="openAdvancedSearch('Recipient')">
      <i class="bi bi-envelope-open-fill"></i> Courriers destinés
    </span>
  </section>
  <section [ngClass]="{ 'overflow-details': !displayedInModalBoolean }">
    <div class="userDetails__contact mb-3">
      <i-title [text]="'contactsDetails.details.contactDetails' | translate" level="3"></i-title>

      <div class="contact mt-2">
        @if (contact?.listContactsAdresses) {
          <div class="contact__body">
            <div class="row mb-2">
              @for (a of contact.listContactsAdresses; track a; let i = $index) {
                <div class="col-lg-4 col-md-4 col-sm-12" [ngClass]="{ 'super-compos-sectionseparator-vertical': i !== 0 }">
                  <div class="row">
                    <div class="col-12">
                      <h4 class="custom-h4-title">{{ a?.type }}</h4>
                    </div>
                  </div>
                  <div class="d-flex align-items-center">
                    <i class="bi bi-telephone mb-2"></i>
                    <div class="mb-2 p-0 ms-3">
                      {{ a?.adresse?.telephone ? a?.adresse?.telephone : ('contactsDetails.details.noPhoneDefined' | translate) }}
                    </div>
                  </div>
                  <div class="d-flex align-items-center">
                    <i class="bi bi-phone mb-2"></i>
                    <div class="mb-2 p-0 ms-3">{{ a?.adresse?.gsm ? a?.adresse?.gsm : ('contactsDetails.details.noMobileDefined' | translate) }}</div>
                  </div>
                  <div class="d-flex align-items-center">
                    <i class="bi bi-at mb-2"></i>
                    <div class="mb-2 p-0 ms-3">
                      <span id="emailContactDetails">{{
                        a?.adresse?.mail ? a?.adresse?.mail : ('contactsDetails.details.noEmailDefined' | translate)
                      }}</span>
                    </div>
                  </div>
                  <div class="d-flex align-items-center">
                    <i class="bi bi-file-earmark-break mb-2"></i>
                    <div class="mb-2 p-0 ms-3">{{ a?.adresse?.fax ? a?.adresse?.fax : ('contactsDetails.details.noFaxDefined' | translate) }}</div>
                  </div>
                </div>
              }
            </div>
            @if (contact?.typeSociete === true) {
              <div>
                <div class="row">
                  @if (contact?.bce) {
                    <div class="col-4">
                      <h4 class="custom-h4-title">{{ 'contactsDetails.details.bce' | translate }}</h4>
                      {{ contact?.bce }}
                    </div>
                  }
                  @if (contact?.gerantSociete) {
                    <div class="col-4">
                      <h4 class="custom-h4-title">{{ 'contactsDetails.details.manager' | translate }}</h4>
                      {{ contact?.gerantSociete }}
                    </div>
                  }
                  @if (contact?.secteurActivite) {
                    <div class="col-4">
                      <h4 class="custom-h4-title">{{ 'contactsDetails.details.sector' | translate }}</h4>
                      {{ contact?.secteurActivite }}
                    </div>
                  }
                </div>
                <div class="row">
                  @if (contact && contact.tva) {
                    <div class="col-4">
                      <h4 class="custom-h4-title">{{ 'contactsDetails.details.vatNumber' | translate }}</h4>
                      {{ contact?.tva }}
                    </div>
                  }
                  @if (contact && !contact.tva) {
                    <div class="col-4">
                      <h4 class="custom-h4-title">{{ 'contactsDetails.details.vatNumber' | translate }}</h4>
                      Pas de numéro belge
                    </div>
                  }
                  @if (contact?.societeFormeJurIdique) {
                    <div class="col-4">
                      <h4 class="custom-h4-title">{{ 'contactsDetails.details.legalForm' | translate }}</h4>
                      {{ contact?.societeFormeJurIdique?.description }}
                    </div>
                  }
                  @if (contact?.signature1) {
                    <div class="col-4">
                      <h4 class="custom-h4-title">{{ 'contactsDetails.details.signature' | translate }}</h4>
                      {{ contact?.signature1 }}
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        }
      </div>
    </div>
    <div class="row d-flex justify-content-between align-items-center mb-2">
      @if (contact && contact.listContactsAdresses) {
        <div class="col-md-8 row">
          @for (ad of contact.listContactsAdresses; track ad) {
            <span class="col-md-6">
              @if (
                ad?.adresse?.impression_Adresse ||
                ad?.adresse?.impression_CodePostal ||
                ad?.adresse?.impression_Localite ||
                ad?.adresse?.impression_Pays
              ) {
                <div>
                  <h4 class="custom-h4-title m-0">{{ ad.type }} <i class="ms-1 bi bi-info-circle" pTooltip="Adresse d'impression"></i></h4>
                  @if (ad?.adresse?.impression_Adresse !== 'null, null null' && ad?.adresse?.impression_Adresse !== 'null') {
                    <p class="m-0">
                      {{ ad?.adresse?.impression_Adresse }}
                    </p>
                  }
                  <p class="m-0" id="codePostalContactDetails">{{ ad?.adresse?.impression_CodePostal }}</p>
                  <p class="m-0" id="localiteContactDetails">{{ ad?.adresse?.impression_Localite }}</p>
                  <p class="m-0" id="paysContactDetails">{{ ad?.adresse?.impression_Pays }}</p>
                  <p class="m-0"></p>
                </div>
              }
            </span>
          }
        </div>
      }
    </div>
    @if (liensSocMembres.length > 0) {
      <div class="mb-4">
        <div class="userDetails__members mb-3">
          <h3 class="super-compos-titre-h3 ms-0" (click)="displayMembersLinks = !displayMembersLinks">
            <span class="me-1">
              <img [ngStyle]="{ transform: displayMembersLinks ? 'rotate(90deg)' : '' }" id="arrow " src="./assets/img/Triangle.svg " alt="arrow " />
            </span>
            {{
              liensSocMembres?.length > 1
                ? ('contactsDetails.details.relatedContacts' | translate)
                : ('contactsDetails.details.relatedContact' | translate)
            }}
            :
            {{ liensSocMembres?.length }}
          </h3>
          @if (displayMembersLinks) {
            <i-table
              class="super-table"
              (onClickDelete)="deleteContact()"
              [columns]="colSociety"
              [items]="liensSocMembres"
              id="MembersLink3 "
              height="40"
              [multiselect]="false">
            </i-table>
          }
        </div>
      </div>
    }

    @if (liensSocSoc.length > 0) {
      <div class="userDetails__companies mb-3">
        <h3 class="super-compos-titre-h3 ms-0" (click)="displaySocietyLinks = !displaySocietyLinks">
          <span class="me-1">
            <img [ngStyle]="{ transform: displaySocietyLinks ? 'rotate(90deg)' : '' }" id="arrow" src="./assets/img/Triangle.svg" alt="arrow" />
          </span>
          @if (liensSocSoc?.length > 1) {
            <span>{{ 'contactsDetails.details.relatedCompanies' | translate }} :</span>
          }
          @if (liensSocSoc?.length <= 1) {
            <span>{{ 'contactsDetails.details.relatedCompany' | translate }} :</span>
          }
          {{ liensSocSoc?.length }}
        </h3>
        @if (displaySocietyLinks) {
          <i-table class="super-table" [columns]="colSociety" [items]="liensSocSoc" id="socLink" height="40" [multiselect]="false"> </i-table>
        }
      </div>
    }
    @if (contact?.typeSociete && (contact?.siteWeb || contact?.siteWeb2)) {
      <div class="userDetails__infos">
        <h3 class="super-compos-titre-h3 mt-1">{{ 'contactsDetails.details.additionalInfo' | translate }}</h3>
        <h4 class="custom-h4-title">{{ 'contactsDetails.details.siteWeb' | translate }}</h4>
        @if (contact?.siteWeb || contact?.siteWeb2) {
          <ul>
            <li>
              <a [href]="contact?.siteWeb" target="_blank" rel="noopener noreferrer" class="linkColor">{{ contact?.siteWeb }}</a>
            </li>
            @if (contact?.siteWeb2) {
              <li>
                <a [href]="contact?.siteWeb2" target="_blank" rel="noopener noreferrer" class="linkColor">{{ contact?.siteWeb2 }}</a>
              </li>
            }
          </ul>
        }
      </div>
    }

    @if (contact?.typeSociete === false || contact?.typeSociete === null) {
      <div class="form__showMore">
        <div class="d-flex justify-content-center">
          @if (!fullMode) {
            <i-button
              [text]="'contactsDetails.details.showAdditionalInformation' | translate"
              (click)="fullMode = !fullMode"
              styleClass="blue showMoreBtn mb-5"
              icon="bi bi-zoom-in"
              id="showMore">
            </i-button>
          }
          @if (fullMode) {
            <i-button
              [text]="'contactsDetails.details.hideAdditionalInformation' | translate"
              (click)="fullMode = !fullMode"
              styleClass="blue showMoreBtn mb-5"
              icon="bi bi-zoom-out"
              id="showMore">
            </i-button>
          }
        </div>
        @if (fullMode) {
          <div>
            <div class="userDetails__infos">
              <h3 class="super-compos-titre-h3 mt-1">{{ 'contactsDetails.details.additionalInfo' | translate }}</h3>
              <div class="row">
                <div class="col-4 mb-3">
                  <h4 class="custom-h4-title">{{ 'contactsDetails.details.contactType' | translate }}</h4>
                  <span id="contactType">{{
                    contact?.typeContact?.typeContact ? contact?.typeContact.typeContact : ('contactsDetails.details.noDefined' | translate)
                  }}</span>
                </div>
                <div class="col-4 mb-3">
                  <h4 class="custom-h4-title">{{ 'contactsDetails.details.title' | translate }}</h4>
                  <span id="contactTitre">{{ contact?.titre ? contact?.titre : ('contactsDetails.details.noDefined' | translate) }}</span>
                </div>
                <div class="col-4 mb-3">
                  <h4 class="custom-h4-title">{{ 'contactsDetails.details.language' | translate }}</h4>
                  <span id="contactLangue">{{ contact?.langue?.description ? contact?.langue?.description : 'Français' }}</span>
                </div>
              </div>
              <div class="row">
                <div class="col-4 mb-3">
                  <h4 class="custom-h4-title">{{ 'contactsDetails.details.internalName' | translate }}</h4>
                  <span id="nomInterne">{{ contact?.nomInterne ? contact?.nomInterne : ('contactsDetails.details.noDefined' | translate) }}</span>
                </div>
                <div class="col-4 mb-3">
                  <h4 class="custom-h4-title">{{ 'contactsDetails.details.placeOfBirth' | translate }}</h4>
                  <span id="naissanceLieu">{{
                    contact?.naissanceLieu ? contact.naissanceLieu : ('contactsDetails.details.noDefined' | translate)
                  }}</span>
                </div>
                <div class="col-4 mb-3">
                  <h4 class="custom-h4-title">{{ 'contactsDetails.details.dateOfBirth' | translate }}</h4>
                  {{
                    contact?.dateNaissance ? $moment(contact?.dateNaissance).format('DD/MM/YYYY') : ('contactsDetails.details.noDefined' | translate)
                  }}
                </div>
              </div>
              <div class="row">
                <div class="col-4 mb-3">
                  <h4 class="custom-h4-title">{{ 'contactsDetails.details.nationalRegistryNumber' | translate }}</h4>
                  {{ contact?.numeroCarteNISS ? contact?.numeroCarteNISS : ('contactsDetails.details.noDefined' | translate) }}
                </div>
                <div class="col-4 mb-3">
                  <h4 class="custom-h4-title">{{ 'contactsDetails.details.maritalStatus' | translate }}</h4>
                  {{ contact?.etatCivil ? contact.etatCivil : ('contactsDetails.details.noDefined' | translate) }}
                </div>
                <div class="col-4 mb-3">
                  <h4 class="custom-h4-title">{{ 'contactsDetails.details.nationality' | translate }}</h4>
                  {{ contact?.nationalite ? contact?.nationalite : ('contactsDetails.details.noDefined' | translate) }}
                </div>
              </div>
              <div class="row">
                <div class="col-4 mb-3">
                  <h4 class="custom-h4-title">{{ 'contactsDetails.details.gender' | translate }}</h4>
                  {{ contact?.sexe ? contact.sexe : ('contactsDetails.details.noDefined' | translate) }}
                </div>
                <div class="col-8 mb-3">
                  <h4 class="custom-h4-title">{{ 'contactsDetails.details.note' | translate }}</h4>
                  <span id="commentaires">
                    {{ contact?.commentaires ? contact.commentaires : ('contactsDetails.details.noDefined' | translate) }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    }
  </section>

  <p-confirmDialog #cd appendTo="body" styleClass="super-compos-modal-content confirmModal" header="Confirmation" icon="bi bi-exclamation-triangle">
    <p-footer>
      <button type="button" pButton icon="pi pi-times" [label]="'global.no' | translate" (click)="cd.reject()"></button>
      <button class="pButtonRed" type="button" pButton icon="pi pi-check" [label]="'global.yes' | translate" (click)="cd.accept()"></button>
    </p-footer>
  </p-confirmDialog>
</div>
